import { FC } from "react";

import { DsIcon } from "../components/ui";
import { classNames } from "../utils/classNames";

type NotesIconPropsType = {
  className?: string;
  iconClassName?: string;
};

const NotesIcon: FC<NotesIconPropsType> = ({ className, iconClassName }) => {
  return (
    <div className={classNames("bg-sos-yellow rounded-lg", className)}>
      <DsIcon icon="Notes" className={classNames("my-1 mx-3", iconClassName)} />
    </div>
  );
};

export { NotesIcon };
